/**
 * The timestamp on a row in a list of activity — a thread, a communication.
 * Progressively coarser as the item ages: a time for something from today, a
 * day and month for this year, the year too for anything older. Shared so web's
 * thread list and native's contact communications read a date the same way.
 */
export const formatActivityDate = (inputDate: Date): string => {
  if (!inputDate) {
    return "";
  }
  const date = new Date(inputDate);
  const now = new Date();
  if (now.toDateString() === date.toDateString()) {
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  } else if (now.getFullYear() === date.getFullYear()) {
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
  }
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};
